import familyIcon from "../assets/images/svg/familyAccess.svg";
import liaisonIcon from "../assets/images/svg/liaisonAccess.svg";
import saveMoneyIcon from "../assets/images/svg/saveMoney.svg";
import manageDeviceIcon from "../assets/images/svg/manageDevice.svg";
import settingLockIcon from "../assets/images/svg/settingLockIcon.svg";
import lockActiveIcon from "../assets/images/svg/lockActiveIcon.svg";
import settingPeopleSelected from "../assets/images/svg/settingPeople.svg";
import peopleNotSelected from "../assets/images/svg/peopleNotSelected.svg";
import settingPhone from "../assets/images/svg/settingPhone.svg";
import settingSaveMoney from "../assets/images/svg/settingSaveMoney.svg";
import reportSince from "../assets/images/svg/reportSince.svg";
import reportSinceActive from "../assets/images/svg/reportSinceActive.svg";
import reportSinceInactive from "../assets/images/svg/reportSinceInactive.svg";
import manageDeviceSelected from "../assets/images/svg/manageDeviceSelected.svg";
import LOProfileSelected from "../assets/images/svg/LOprofileSelected.svg";
import LOProfileNotSelected from "../assets/images/svg/LOprofileNotSelected.svg";
import LOProfileIcon from "../assets/images/svg/LOprofileIcon.svg";
import investmentWithSelected from "../assets/images/svg/investment_with_selected.svg";
import { getPerfOverallExcelPercentage } from "./functions";

export const showMeStocks = "Show me only stocks I’m holding";
export const fromSnippetSub = "home-snippet-subAssets";
export const family_modal_title = "Select Family Member";

export const ttRedColorArr = [
  "sold",
  "corpus out",
  "split out",
  "corp action sell",
];

export const HOME_PAGE = "Home Page";
export const PORTFOLIO_PAGE = "Portfolio Page";
export const VIEW_INFINITY = "View Infinity Quick Views Page";
export const QUICK_VIEWS = "Quick Views Page";
export const PERFORMANCE_PAGE = "Performance Page";
export const PROFILE_PAGE = "Profile Page";
export const SETTINGS_PAGE = "Settings Page";
export const CONNECT_PAGE = "Connect Page";
export const REPORTS_PAGE = "Reports Page";
export const ANALYTICS_PAGE = "Analytics Page";

export const FINANCIAL = "Financial Assets";
export const LIABILITTIES = "Liabilities";
export const DERIVATIVES = "Derivatives";
export const REAL_ESTATE = "Real Estate";

export const RECENT_TRANSACTIONS = "Recent Transactions";
export const UPCOMING_TRANSACTIONS = "Upcoming Transactions";
export const RECENT_CORPORATE_ACTIONS = "Recent Corporate Actions";
export const UPCOMING_CORPORATE_ACTIONS = "Upcoming Corporate Actions";
export const VIEW_TRANSACTIONS = "View Infinity Transactions";
export const VIEW_CORPORATES = "View Infinity Corporate Actions";
export const PORTFOLIO = "Portfolio Reports";
export const TAX = "Tax Reports";
export const UNREALISED = "Unrealised Gain/Loss Reports";
export const LEDGER = "Ledger Report";
export const MARGIN = "Marging Statement Report";
export const BILLS = "Bills and Contract Report";
export const OVERALL = "Overall";

export const CLIENT_LOGIN_1 = "Client Login 1";
export const CLIENT_LOGIN_2 = "Client Login 2";
export const CLIENT_LOGOUT = "Client Logout";
export const EMPLOYEE = "Employee Login";
export const EMPLOYEE_LOGOUT = "Employee Logout";
export const LIAISON_1 = "LO Login 1";
export const LIAISON_2 = "LO Login 2";
export const LIAISON_LOGOUT = "LO Logout";

export const CLIENT = "Client";
export const EMPLOYEE_TYPE = "Employee";
export const LIAISON = "Liaison";

export const GALLERY = "Gallery";
export const SKIP = "Skip";
export const OTP = "OTP";

export const portfolioReportMsg = `For "Generate Excel" option, only "Holding Statement" will get downloaded in Excel file. For other details, refer PDF option`;

export const oneDayDif = 86400000;

export const movePer = ((320 + 25) / 1440) * 100;

export const taxReportAlphanumKeys = {
  securityClass: true,
  isin: true,
  displayName: true,
  folioNo: true,
};

export const taxReportDateKeys = {
  sellDate: true,
  buyDate: true,
  redemptionDate: true,
};

export const taxReportNumberKeys = {
  otherChargesSell: true,
  sttSell: true,
  otherChargesBuy: true,
  sttBuy: true,
  stampDuty: true,
  brokerage: true,
  shortTerm_GL: true,
  holdingDays: true,
  longTermCapitalGainsWithoutIndexation: true,
  longTermCapitalGainsWithIndexation: true,
  ltp: true,
  indexationValue: true,
  indexationPrice: true,
  sellValue: true,
  buyValue: true,
  sellPrice: true,
  gfPrice: true,
  buyPrice: true,
  quantity: true,
  unitCost: true,
  redemptionPrice: true,
  redemptionUnits: true,
  redemptionValue: true,
  sttRedemption: true,
  longTerm_GL: true,
  taxableGL: true,
  taxableGLWithIndexation: true,
  taxableGainLosswithoutIndexation: true,
};

export const analyticsId = {
  Overall: 0,
  Equity: 1,
  "Fixed Income": 2,
};

export const denominationObject = {
  Lakhs: 0,
  Crores: 1,
  Absolute: 3,
  Thousands: null,
  Millions: null,
  "Lakhs/Thousands": null,
  "Crores/Millions": null,
};

export const snippetDefaultData = {
  data: [],
  performanceStatus: {
    isFetching: true,
    isError: false,
  },
  analyticsStatus: {
    isFetching: true,
    isError: false,
  },
};

export const familyViewTabs = [
  {
    name: "assets",
    id: 0,
    img: {
      notSelectedImg: settingSaveMoney,
      selectedImg: investmentWithSelected,
    },
  },
  {
    name: "family",
    id: 1,
    img: {
      selectedImg: settingPeopleSelected,
      notSelectedImg: peopleNotSelected,
    },
  },
];

export const offshoreFamilyViewTabs = [
  {
    name: "assets",
    id: 0,
    img: {
      notSelectedImg: settingSaveMoney,
      selectedImg: investmentWithSelected,
    },
  },
  // {
  //   name: "family",
  //   id: 1,
  //   img: {
  //     selectedImg: settingPeopleSelected,
  //     notSelectedImg: peopleNotSelected,
  //   },
  // },
];

export const tabData = [
  {
    id: 0,
    name: "MTD",
  },
  {
    id: 1,
    name: "QTD",
  },
  {
    id: 2,
    name: "YTD",
  },
  {
    id: 3,
    name: "ITD",
  },
];

export const clickableButton = {
  background: "transparent",
  border: "none",
  height: "fit-content",
};

export const allocationColorsStatic = {
  2: "#C59331",
  4: "#03002F",
  3: "#E0D0AF",
  5: "#696683",
  0: "#B4B3C1",
  100: "#E0D0AF",
};

export const familyOfficeTeamNameText = "Family Office Team";

export const addFamilyOfficeTeamRoute = "add-family-office-team";

export const editFamilyOfficeTeamRoute = "edit-family-office-team";

export const familyMemberAccessType = {
  activeImage: settingPeopleSelected,
  notActiveImage: peopleNotSelected,
  heading: "Family Member Access",
  key: "family_member_access",
  image: familyIcon,
  accessibleBy: ["customer"],
};
export const liaisonOfficerAccessType = {
  activeImage: lockActiveIcon,
  notActiveImage: settingLockIcon,
  heading: `${familyOfficeTeamNameText} Access`,
  key: "liaison_office_access",
  image: liaisonIcon,
  accessibleBy: ["customer"],
};
export const manageDeviceType = {
  activeImage: manageDeviceSelected,
  notActiveImage: settingPhone,
  heading: "Manage Devices",
  key: "manage_devices",
  image: manageDeviceIcon,
  accessibleBy: ["customer"],
};
export const LiaisonProfileType = {
  activeImage: LOProfileSelected,
  notActiveImage: LOProfileNotSelected,
  heading: "Change Profile Photo",
  key: "change_profile_photo",
  image: LOProfileIcon,
  accessibleBy: ["manager"],
};
// export const notificationType={
//   activeImage: bellIconSelected,
//   notActiveImage: bellIconNotSelected,
//   heading: "Notification Settings",
//   key: "notification_settings",
//   image: bellIconDropdownIcon,
//   accessibleBy: ["customer", "manager", "employee"],
// };
export const investmentHeldWithType = {
  activeImage: investmentWithSelected,
  notActiveImage: settingSaveMoney,
  heading: "Investments Held with",
  key: "investments_held_with",
  image: saveMoneyIcon,
  accessibleBy: ["customer"],
};
export const reportSinceType = {
  activeImage: reportSinceActive,
  notActiveImage: reportSinceInactive,
  heading: "Report Since",
  key: "report_type",
  image: reportSince,
  customCls: "report_since",
  accessibleBy: ["customer"],
};

export const settingsMenuDetails = [
  familyMemberAccessType,
  liaisonOfficerAccessType,
  manageDeviceType,
  LiaisonProfileType,
  investmentHeldWithType,
  reportSinceType,
];

export const primaryClientsSettingOptions = [
  familyMemberAccessType,
  liaisonOfficerAccessType,
  manageDeviceType,
  investmentHeldWithType,
  reportSinceType,
];

export const nonPrimaryClientsSettingOptions = [
  manageDeviceType,
  investmentHeldWithType,
  reportSinceType,
];

export const LOSettingOptions = [LiaisonProfileType];

export const MANAGER = "manager";
export const PRIMARY_CUSTOMER = "primaryCustomer";
export const NON_PRIMARY_CUSTOMER = "nonPrimaryCustomer";
export const EMPLOYEE_TYPE_LOGIN = "employee";

export const allUsersSetting = {
  primaryCustomer: primaryClientsSettingOptions,
  nonPrimaryCustomer: nonPrimaryClientsSettingOptions,
  manager: LOSettingOptions,
  employee: [],
};

// export const settingsMenuDetails = [
//   {
//     activeImage: settingPeopleSelected,
//     notActiveImage: peopleNotSelected,
//     heading: "Family Member Access",
//     key: "family_member_access",
//     image: familyIcon,
//     accessibleBy: ["customer"],
//   },
//   {
//     activeImage: lockActiveIcon,
//     notActiveImage: settingLockIcon,
//     heading: "Liaison Officer Access",
//     key: "liaison_office_access",
//     image: liaisonIcon,
//     accessibleBy: ["customer"],
//   },
//   {
//     activeImage: manageDeviceSelected,
//     notActiveImage: settingPhone,
//     heading: "Manage Devices",
//     key: "manage_devices",
//     image: manageDeviceIcon,
//     accessibleBy: ["customer"],
//   },
//   {
//     activeImage: LOProfileSelected,
//     notActiveImage: LOProfileNotSelected,
//     heading: "Change Profile Photo",
//     key: "change_profile_photo",
//     image: LOProfileIcon,
//     accessibleBy: ["manager"],
//   },
//   // {
//   //   activeImage: bellIconSelected,
//   //   notActiveImage: bellIconNotSelected,
//   //   heading: "Notification Settings",
//   //   key: "notification_settings",
//   //   image: bellIconDropdownIcon,
//   //   accessibleBy: ["customer", "manager", "employee"],
//   // },
//   {
//     activeImage: investmentWithSelected,
//     notActiveImage: settingSaveMoney,
//     heading: "Investments Held with",
//     key: "investments_held_with",
//     image: saveMoneyIcon,
//     accessibleBy: ["customer"],
//   },
//   {
//     activeImage: reportSinceActive,
//     notActiveImage: reportSinceInactive,
//     heading: "Report Since",
//     key: "report_type",
//     image: reportSince,
//     customCls: "report_since",
//     accessibleBy: ["customer"],
//   },
// ];

export const reportsMenuDetails = [
  {
    heading: "Transactions",
    key: "transactions-report",
    navigateTo: "/reports/transactions-report",
  },
  {
    heading: "Corporate Actions",
    key: "transactions-corporate-action-report",
    navigateTo: "/reports/transactions-corporate-action-report",
  },
  {
    heading: "Portfolio Report",
    key: "portfolio-report",
    navigateTo: "/reports/portfolio-report",
  },
  {
    heading: "Tax Report",
    key: "tax-report",
    navigateTo: "/reports/tax-report",
  },
  {
    heading: "Unrealised Gain/Loss Report",
    key: "unrealised-gain-loss-report",
    navigateTo: "/reports/unrealised-gain-loss-report",
  },
  {
    heading: "Ledger Report",
    key: "ledger-report",
    navigateTo: "/reports/ledger-report",
  },
  // {
  //   heading: "Margin Statement Report",
  //   key: "margin-statement-report",
  //   navigateTo: "/reports/margin-statement-report",
  // },
  {
    heading: "Bills and Contract Notes",
    key: "bills-and-contract-notes",
    navigateTo: "/reports/bills-and-contract-notes",
  },
];

export const analyticsProfileDropDown = [
  {
    heading: "Praveen Desai",
    key: "option-1",
  },
  {
    heading: "Abhijit Shinde",
    key: "option-2",
  },
];

export const analyticsCategories = [
  {
    heading: "Derivatives",
    key: "category-1",
  },
  {
    heading: "Alternatives",
    key: "category-2",
  },
];

export const timePeriodRadioBtnsData = [
  {
    title: "Current Month",
    value: "current_month",
  },
  {
    title: "Previous Month",
    value: "previous_month",
  },
  {
    title: "Current FY",
    value: "current_fy",
  },
  {
    title: "Previous FY",
    value: "previous_fy",
  },
  {
    title: "Current Quarter",
    value: "current_quarter",
  },
  {
    title: "Previous Quarter",
    value: "previous_quarter",
  },
  {
    title: "Custom",
    value: "custom",
  },
];
export const timePeriodBillsData = [
  {
    title: "This Week",
    value: "this_week",
  },
  {
    title: "Past Week",
    value: "past_week",
  },
  {
    title: "This Month",
    value: "this_month",
  },
  {
    title: "Past Month",
    value: "past_month",
  },
  {
    title: "Custom",
    value: "custom",
  },
];
export const reportTypeBillsData = [
  {
    title: "Contract Notes",
    value: "1",
  },
  {
    title: "Bills",
    value: "2",
  },
];
export const segmentBillsData = [
  {
    title: "All",
    value: "0",
  },
  {
    title: "Cash",
    value: "1",
  },
  {
    title: "F&O",
    value: "2",
  },
  {
    title: "Currency",
    value: "3",
  },
];
export const marginStatementByTypesData = [
  {
    title: "Overview ",
    value: "Overview",
  },
  {
    title: "Valuation Report",
    value: "Valuation",
  },
];

export const acocuntsData = [
  {
    title: "Praveen Desai POA",
    id: "0",
  },
  {
    title: "Prashanth Desai Non Exchange",
    id: "1",
  },
  {
    title: "Niharika Desai Executionary",
    id: "2",
  },
];
export const investmentData = [
  {
    title: "Equity",
    id: "0",
  },
  {
    title: "Fixed Income",
    id: "1",
  },
];
export const stocksData = [
  {
    title: "Mutual Funds - Equity",
    id: "0",
  },
  {
    title: "Direct Equity/Stocks",
    id: "1",
  },
];
export const billsNotesTableData = [
  {
    date: "13 Nov 2017",
    segment: "BSC - Cash",
    id: "0",
  },
  {
    date: "13 Nov 2017",
    segment: "BSC - Cash",
    id: "1",
  },
  {
    date: "13 Nov 2017",
    segment: "BSC - Cash",
    id: "2",
  },
  {
    date: "13 Nov 2017",
    segment: "BSC - Cash",
    id: "3",
  },
  {
    date: "13 Nov 2017",
    segment: "BSC - Cash",
    id: "4",
  },
  {
    date: "13 Nov 2017",
    segment: "BSC - Cash",
    id: "5",
  },
];
export const marginStatementParticularsData = [
  {
    title: "Cash and Cash Equivalent",
    contentData: [
      {
        heading: "Cash Available",
        value: "₹ 20,10,556.00",
      },
      {
        heading: "Cash Receivable",
        value: " ₹ 15,90,155.00",
      },
      {
        heading: "Net Cash Value (A)",
        value: " ₹ 15,90,155.00",
      },
    ],
  },
  {
    title: "Equity and other Assets in your Demat*",
    contentData: [
      {
        heading: "Stocks Value",
        value: " ₹ 15,90,155.00",
      },
      {
        heading: "Mutual Funds Value",
        value: " ₹ 15,90,155.00",
      },
      {
        heading: "Assets Value (B)",
        value: " ₹ 20,10,556.00",
      },
      {
        heading: "Total Assets (A+B)",
        value: " ₹ 20,10,556.00",
      },
    ],
  },
  {
    title: "Margin Calculation",
    contentData: [
      {
        heading: "Net Asset Value Post Haircut",
        value: "₹ 20,10,556.00",
      },
      {
        heading: "Margin Blocked for Derivatives",
        value: " ₹ 20,10,556.00",
      },
      {
        heading: "Free Margin to Trade",
        value: " ₹ 15,90,155.00",
      },
    ],
  },
  {
    title: "Funds in transit (not considered in Assets and Margin)",
    contentData: [
      {
        heading: "Uncleared Cheque Value",
        value: " ₹ 15,90,155.00",
      },
    ],
  },
];

export const checkBoxesData = [
  {
    key: "executiveSummary",
    title: "Executive summary",
  },
  {
    key: "performance",
    title: "Performance",
  },
  {
    key: "holdingStatement",
    title: "Holding Statement",
  },
  {
    key: "transactions",
    title: "Transactions",
  },
  {
    key: "profile",
    title: "Profile",
  },
];

export const ledgertimePeriodRadioBtnsData = [
  {
    title: "Current Month",
    value: "this_month",
  },
  {
    title: "Previous Month",
    value: "previous_month",
  },
  {
    title: "Current FY",
    value: "current_year",
  },
  {
    title: "Previous FY",
    value: "previous_year",
  },
  {
    title: "Current Quarter",
    value: "this_quarter",
  },
  {
    title: "Previous Quarter",
    value: "previous_quarter",
  },
  {
    title: "Custom",
    value: "custom",
  },
];

export const ledgertimePeriodRadioBtnsDataDetailedView = [
  {
    title: "Current Month",
    value: "this_month",
  },
  {
    title: "Previous Month",
    value: "previous_month",
  },
  {
    title: "Current FY",
    value: "current_year",
  },
  {
    title: "Previous FY",
    value: "previous_year",
  },
  {
    title: "Current Quarter",
    value: "this_quarter",
  },
  {
    title: "Previous Quarter",
    value: "previous_quarter",
  },
  {
    title: "Custom",
    value: "custom",
  },
];
export const ledgerReportTypeBillsData = [
  {
    title: "Snapshot",
    value: "snapshot",
  },
  {
    title: "Detailed View",
    value: "detailed_view",
  },
];
export const segmentsData = [
  {
    title: "All",
    id: "1",
  },
  {
    title: "Cash",
    id: "2",
  },
  {
    title: "F&O",
    id: "3",
  },
  {
    title: "Currency",
    id: "4",
  },
  {
    title: "Mutual Funds",
    id: "5",
  },
  {
    title: "Funds Bought In",
    id: "6",
  },
  {
    title: "Funds Moved Out",
    id: "7",
  },
];
export const ledgerSnapshotData = [
  {
    title: "Activity in Your Account",
    contentData: [
      {
        heading: "Opening Balance",
        value: "₹ 20,10,556.00",
      },
    ],
  },
  {
    title: "Inflow / Outflow",
    contentData: [
      {
        heading: "Funds Received from you",
        value: " ₹ 15,90,155.00",
      },
      {
        heading: "Funds Withdrawn by you",
        value: " ₹ 15,90,155.00",
      },
    ],
  },
  {
    title: "Funds Utilisation (segment wise breakup of transactions",
    contentData: [
      {
        heading: "Cash Segment",
        value: "₹ 20,10,556.00",
      },
      {
        heading: "Derivatives Segment",
        value: " ₹ 20,10,556.00",
      },
      {
        heading: "MFSS Segment",
        value: " ₹ 15,90,155.00",
      },
      {
        heading: "IPO / Bonds / NCDs",
        value: " ₹ 15,90,155.00",
      },
    ],
  },
  {
    title: "Miscellaneous",
    contentData: [
      {
        heading: "Reversals, Charges and Others",
        value: " ₹ 15,90,155.00",
      },
      {
        heading: "Reversals, Charges and Others",
        value: " ₹ 15,90,155.00",
      },
      {
        heading: "Closing Balance",
        value: " ₹ 15,90,155.00",
      },
    ],
  },
];
export const transectionsTimePeriodRadioBtnsData = [
  {
    title: "Current Month",
    value: "current_month",
  },
  {
    title: "Previous Month",
    value: "previous_month",
  },
  {
    title: "Current FY",
    value: "current_fy",
  },
  {
    title: "Previous FY",
    value: "previous_fy",
  },
  {
    title: "Current Quarter",
    value: "current_quarter",
  },
  {
    title: "Previous Quarter",
    value: "previous_quarter",
  },
  {
    title: "ITD",
    value: "itd",
  },
  {
    title: "Custom",
    value: "custom",
  },
];

export const CorporatetimePeriodRadioBtnsData = [
  {
    title: "Current Month",
    value: "current_month",
  },
  {
    title: "Previous Month",
    value: "previous_month",
  },
  {
    title: "Current FY",
    value: "current_fy",
  },
  {
    title: "Previous FY",
    value: "previous_fy",
  },
  {
    title: "Custom",
    value: "custom",
  },
];
export const CorporateTranTypeRadioBtnsData = [
  {
    title: "Interest",
    value: "interest",
  },
  {
    title: "Dividend",
    value: "dividend",
  },
  {
    title: "Split",
    value: "split",
  },
  {
    title: "Principal Payback",
    value: "principle_payback",
  },
  {
    title: "Buyback",
    value: "buyback",
  },
  {
    title: "Rights Issued",
    value: "rights_issued",
  },
  {
    title: "Bonus",
    value: "bonus",
  },
  {
    title: "Others",
    value: "others",
  },
  {
    title: "All",
    value: "all",
  },
];
export const assetClassData = [
  {
    title: "All Asset Classes",
    id: "0",
  },
  {
    title: "Equity",
    id: "1",
  },
  {
    title: "Fixed Income",
    id: "2",
  },
];
export const TaxtimePeriodRadioBtnsData = [
  {
    title: "Current Month",
    value: "current_month",
  },
  {
    title: "Previous Month",
    value: "previous_month",
  },
  {
    title: "Current Quarter",
    value: "current_quarter",
  },
  {
    title: "Previous Quarter",
    value: "previous_quarter",
  },
  {
    title: "Current FY",
    value: "current_fy",
  },
  {
    title: "Previous FY",
    value: "previous_fy",
  },
  {
    title: "Custom",
    value: "custom",
  },
];
export const changesRadioBtnsData = [
  {
    title: "With Charges",
    value: "0",
  },
  {
    title: "Without Charges",
    value: "1",
  },
];

export const analyticsTooltipContent =
  "*This Data only Captures instruments in Direct Equity and Equity in Mutual Fund";

export const option5Details2 = ["93"];
export const option1Details2 = ["15"];
export const option2Details2 = ["51", "53", "60", "58", "57"];
export const option3Details2 = ["7", "36", "38", "52", "61", "81", "72"];
export const option4Details2 = [
  "2",
  "13",
  "17",
  "55",
  "54",
  "62",
  "63",
  "64",
  "66",
  "69",
  "70",
  "76",
  "83",
  "88",
];

export const familyTableData = [
  {
    clientcode: "1",
    id: 25,
    assetClass: {
      clientcode: "1",
      id: 2,
      name: "Equity",
      defaultIndex: {
        clientcode: null,
        id: 0,
        name: null,
      },
    },
    allocation_percentage: "",
    investmentreturn: {
      clientcode: "1",
      as_of_date: "2023-11-27",
      current_value: {
        actual_value: "128789778.00",
        value: "12.88",
        value_type: "Cr",
      },
      total_returns: {
        actual_value: null,
        value: null,
        value_type: null,
      },
      irr: "17.46",
      invested_value: {
        actual_value: "109110798.73",
        value: "10.91",
        value_type: "Cr",
      },
      int_div: {
        amount: {
          actual_value: "0.00000",
          value: "0.00",
          value_type: "",
        },
        percentage: null,
      },
      unrealised_gain: {
        amount: {
          actual_value: "19678979.27",
          value: "1.97",
          value_type: "Cr",
        },
        percentage: "18.04",
      },
      realised_gain: {
        amount: {
          actual_value: "37737343.79000001",
          value: "3.77",
          value_type: "Cr",
        },
        percentage: "",
      },
      measureinstrumentid: null,
      commitment_val: null,
      maturity_Date: null,
    },
    instrumentVehiclesList: [
      {
        clientcode: "1",
        id: 58,
        consoleassetid: 2,
        assetClass: {
          clientcode: "1",
          id: 58,
          name: "Mutual Funds - Equity ",
          defaultIndex: {
            clientcode: null,
            id: 0,
            name: null,
          },
        },
        allocation_percentage: "10.51",
        investmentreturn: {
          clientcode: "1",
          as_of_date: "2023-11-27",
          current_value: {
            actual_value: "40702500.2200",
            value: "4.07",
            value_type: "Cr",
          },
          total_returns: {
            actual_value: "9314608.7300",
            value: "93.15",
            value_type: "lacs",
          },
          irr: "17.56",
          invested_value: {
            actual_value: "31387891.4900",
            value: "3.14",
            value_type: "Cr",
          },
          int_div: {
            amount: {
              actual_value: "0.0000",
              value: "0.00",
              value_type: "",
            },
            percentage: null,
          },
          unrealised_gain: {
            amount: {
              actual_value: "9314608.7300",
              value: "93.15",
              value_type: "lacs",
            },
            percentage: "29.68",
          },
          realised_gain: {
            amount: {
              actual_value: "0.0000",
              value: "0.00",
              value_type: "",
            },
            percentage: "",
          },
          measureinstrumentid: null,
          commitment_val: null,
          maturity_Date: null,
        },
      },
      {
        clientcode: "1",
        id: 18,
        consoleassetid: 2,
        assetClass: {
          clientcode: "1",
          id: 18,
          name: "Equity - PMS",
          defaultIndex: {
            clientcode: null,
            id: 0,
            name: null,
          },
        },
        allocation_percentage: "4.65",
        investmentreturn: {
          clientcode: "1",
          as_of_date: "2023-11-27",
          current_value: {
            actual_value: "18005408.0600",
            value: "1.80",
            value_type: "Cr",
          },
          total_returns: {
            actual_value: "3156703.8100",
            value: "29.85",
            value_type: "lacs",
          },
          irr: "36.41",
          invested_value: {
            actual_value: "15192382.7300",
            value: "1.52",
            value_type: "Cr",
          },
          int_div: {
            amount: {
              actual_value: "171839.2400",
              value: "1.72",
              value_type: "lacs",
            },
            percentage: null,
          },
          unrealised_gain: {
            amount: {
              actual_value: "2813025.3300",
              value: "28.13",
              value_type: "lacs",
            },
            percentage: "18.52",
          },
          realised_gain: {
            amount: {
              actual_value: "0.0000",
              value: "0.00",
              value_type: "",
            },
            percentage: "",
          },
          measureinstrumentid: null,
          commitment_val: null,
          maturity_Date: null,
        },
      },
      {
        clientcode: "1",
        id: 55,
        consoleassetid: 2,
        assetClass: {
          clientcode: "1",
          id: 55,
          name: "Equity - AIF",
          defaultIndex: {
            clientcode: null,
            id: 0,
            name: null,
          },
        },
        allocation_percentage: "18.09",
        investmentreturn: {
          clientcode: "1",
          as_of_date: "2023-11-27",
          current_value: {
            actual_value: "70081869.5900",
            value: "7.01",
            value_type: "Cr",
          },
          total_returns: {
            actual_value: "45170433.7000",
            value: "4.52",
            value_type: "Cr",
          },
          irr: "15.96",
          invested_value: {
            actual_value: "62530524.5100",
            value: "6.25",
            value_type: "Cr",
          },
          int_div: {
            amount: {
              actual_value: "0.0000",
              value: "0.00",
              value_type: "",
            },
            percentage: null,
          },
          unrealised_gain: {
            amount: {
              actual_value: "7551345.2000",
              value: "75.51",
              value_type: "lacs",
            },
            percentage: "12.08",
          },
          realised_gain: {
            amount: {
              actual_value: "37619088.5000",
              value: "3.76",
              value_type: "Cr",
            },
            percentage: "",
          },
          measureinstrumentid: null,
          commitment_val: null,
          maturity_Date: null,
        },
      },
    ],
  },
  {
    clientcode: "1",
    id: 4,
    assetClass: {
      clientcode: "1",
      id: 4,
      name: "Fixed Income",
      defaultIndex: {
        clientcode: null,
        id: 0,
        name: null,
      },
    },
    allocation_percentage: "",
    investmentreturn: {
      clientcode: "1",
      as_of_date: "2023-11-27",
      current_value: {
        actual_value: "31490411.85",
        value: "3.15",
        value_type: "Cr",
      },
      total_returns: {
        actual_value: null,
        value: null,
        value_type: null,
      },
      irr: "7.51",
      invested_value: {
        actual_value: "29060635.39",
        value: "2.91",
        value_type: "Cr",
      },
      int_div: {
        amount: {
          actual_value: "0.00000",
          value: "0.00",
          value_type: "",
        },
        percentage: null,
      },
      unrealised_gain: {
        amount: {
          actual_value: "2429776.46",
          value: "24.30",
          value_type: "lacs",
        },
        percentage: "8.36",
      },
      realised_gain: {
        amount: {
          actual_value: "608117.64",
          value: "6.08",
          value_type: "lacs",
        },
        percentage: "",
      },
      measureinstrumentid: null,
      commitment_val: null,
      maturity_Date: null,
    },
    instrumentVehiclesList: [
      {
        clientcode: "1",
        id: 57,
        consoleassetid: 4,
        assetClass: {
          clientcode: "1",
          id: 57,
          name: "Mutual Funds - Debt ",
          defaultIndex: {
            clientcode: null,
            id: 0,
            name: null,
          },
        },
        allocation_percentage: "0.02",
        investmentreturn: {
          clientcode: "1",
          as_of_date: "2023-11-27",
          current_value: {
            actual_value: "66356.3500",
            value: "66.36",
            value_type: "k",
          },
          total_returns: {
            actual_value: "350054.6600",
            value: "3.50",
            value_type: "lacs",
          },
          irr: "3.09",
          invested_value: {
            actual_value: "60635.3900",
            value: "60.64",
            value_type: "k",
          },
          int_div: {
            amount: {
              actual_value: "0.0000",
              value: "0.00",
              value_type: "",
            },
            percentage: null,
          },
          unrealised_gain: {
            amount: {
              actual_value: "5720.9600",
              value: "5.72",
              value_type: "k",
            },
            percentage: "9.44",
          },
          realised_gain: {
            amount: {
              actual_value: "344333.7000",
              value: "3.44",
              value_type: "lacs",
            },
            percentage: "",
          },
          measureinstrumentid: null,
          commitment_val: null,
          maturity_Date: null,
        },
      },
      {
        clientcode: "1",
        id: 36,
        consoleassetid: 4,
        assetClass: {
          clientcode: "1",
          id: 36,
          name: "Structured Products - Debt",
          defaultIndex: {
            clientcode: null,
            id: 0,
            name: null,
          },
        },
        allocation_percentage: "4.08",
        investmentreturn: {
          clientcode: "1",
          as_of_date: "2023-11-27",
          current_value: {
            actual_value: "15812769.2700",
            value: "1.58",
            value_type: "Cr",
          },
          total_returns: {
            actual_value: "1812769.2700",
            value: "18.13",
            value_type: "lacs",
          },
          irr: "14.51",
          invested_value: {
            actual_value: "14000000.0000",
            value: "1.40",
            value_type: "Cr",
          },
          int_div: {
            amount: {
              actual_value: "0.0000",
              value: "0.00",
              value_type: "",
            },
            percentage: null,
          },
          unrealised_gain: {
            amount: {
              actual_value: "1812769.2700",
              value: "18.13",
              value_type: "lacs",
            },
            percentage: "12.95",
          },
          realised_gain: {
            amount: {
              actual_value: "0.0000",
              value: "0.00",
              value_type: "",
            },
            percentage: "",
          },
          measureinstrumentid: null,
          commitment_val: null,
          maturity_Date: null,
        },
      },
      {
        clientcode: "1",
        id: 61,
        consoleassetid: 4,
        assetClass: {
          clientcode: "1",
          id: 61,
          name: "Debt - Deposits",
          defaultIndex: {
            clientcode: null,
            id: 0,
            name: null,
          },
        },
        allocation_percentage: "4.03",
        investmentreturn: {
          clientcode: "1",
          as_of_date: "2023-11-27",
          current_value: {
            actual_value: "15611286.2200",
            value: "1.56",
            value_type: "Cr",
          },
          total_returns: {
            actual_value: "611286.2200",
            value: "6.11",
            value_type: "lacs",
          },
          irr: "7.83",
          invested_value: {
            actual_value: "15000000.0000",
            value: "1.50",
            value_type: "Cr",
          },
          int_div: {
            amount: {
              actual_value: "0.0000",
              value: "0.00",
              value_type: "",
            },
            percentage: null,
          },
          unrealised_gain: {
            amount: {
              actual_value: "611286.2200",
              value: "6.11",
              value_type: "lacs",
            },
            percentage: "4.08",
          },
          realised_gain: {
            amount: {
              actual_value: "0.0000",
              value: "0.00",
              value_type: "",
            },
            percentage: "",
          },
          measureinstrumentid: null,
          commitment_val: null,
          maturity_Date: null,
        },
      },
    ],
  },
  {
    clientcode: "1",
    id: 5,
    assetClass: {
      clientcode: "1",
      id: 5,
      name: "Alternatives",
      defaultIndex: {
        clientcode: null,
        id: 0,
        name: null,
      },
    },
    allocation_percentage: "",
    investmentreturn: {
      clientcode: "1",
      as_of_date: "2023-11-27",
      current_value: {
        actual_value: "227026787.59",
        value: "22.70",
        value_type: "Cr",
      },
      total_returns: {
        actual_value: null,
        value: null,
        value_type: null,
      },
      irr: "13.27",
      invested_value: {
        actual_value: "209486204.50",
        value: "20.95",
        value_type: "Cr",
      },
      int_div: {
        amount: {
          actual_value: "0.00000",
          value: "0.00",
          value_type: "",
        },
        percentage: null,
      },
      unrealised_gain: {
        amount: {
          actual_value: "17540583.09",
          value: "1.75",
          value_type: "Cr",
        },
        percentage: "8.37",
      },
      realised_gain: {
        amount: {
          actual_value: "0",
          value: "0.00",
          value_type: "",
        },
        percentage: "",
      },
      measureinstrumentid: null,
      commitment_val: null,
      maturity_Date: null,
    },
    instrumentVehiclesList: [
      {
        clientcode: "1",
        id: 63,
        consoleassetid: 5,
        assetClass: {
          clientcode: "1",
          id: 63,
          name: "Alternatives - Real Estate",
          defaultIndex: {
            clientcode: null,
            id: 0,
            name: null,
          },
        },
        allocation_percentage: "1.45",
        investmentreturn: {
          clientcode: "1",
          as_of_date: "2023-11-27",
          current_value: {
            actual_value: "5598626.0800",
            value: "55.99",
            value_type: "lacs",
          },
          total_returns: {
            actual_value: "3365986.1000",
            value: "9.27",
            value_type: "lacs",
          },
          irr: "2.59",
          invested_value: {
            actual_value: "9000000.0000",
            value: "90.00",
            value_type: "lacs",
          },
          int_div: {
            amount: {
              actual_value: "2438986.2600",
              value: "24.39",
              value_type: "lacs",
            },
            percentage: null,
          },
          unrealised_gain: {
            amount: {
              actual_value: "-1511986.4200",
              value: "-15.12",
              value_type: "lacs",
            },
            percentage: "-16.80",
          },
          realised_gain: {
            amount: {
              actual_value: "0.0000",
              value: "0.00",
              value_type: "",
            },
            percentage: "",
          },
          measureinstrumentid: null,
          commitment_val: null,
          maturity_Date: null,
        },
      },
      {
        clientcode: "1",
        id: 54,
        consoleassetid: 5,
        assetClass: {
          clientcode: "1",
          id: 54,
          name: "Alternatives - Debt",
          defaultIndex: {
            clientcode: null,
            id: 0,
            name: null,
          },
        },
        allocation_percentage: "44.02",
        investmentreturn: {
          clientcode: "1",
          as_of_date: "2023-11-27",
          current_value: {
            actual_value: "170504429.6700",
            value: "17.05",
            value_type: "Cr",
          },
          total_returns: {
            actual_value: "67403825.7300",
            value: "4.16",
            value_type: "Cr",
          },
          irr: "15.60",
          invested_value: {
            actual_value: "165211980.0000",
            value: "16.52",
            value_type: "Cr",
          },
          int_div: {
            amount: {
              actual_value: "25762494.0300",
              value: "2.58",
              value_type: "Cr",
            },
            percentage: null,
          },
          unrealised_gain: {
            amount: {
              actual_value: "15878837.6700",
              value: "1.59",
              value_type: "Cr",
            },
            percentage: "9.61",
          },
          realised_gain: {
            amount: {
              actual_value: "0.0000",
              value: "0.00",
              value_type: "",
            },
            percentage: "",
          },
          measureinstrumentid: null,
          commitment_val: null,
          maturity_Date: null,
        },
      },
      {
        clientcode: "1",
        id: 2,
        consoleassetid: 5,
        assetClass: {
          clientcode: "1",
          id: 2,
          name: "Alternatives - Others",
          defaultIndex: {
            clientcode: null,
            id: 0,
            name: null,
          },
        },
        allocation_percentage: "13.15",
        investmentreturn: {
          clientcode: "1",
          as_of_date: "2023-11-27",
          current_value: {
            actual_value: "50923731.8400",
            value: "5.09",
            value_type: "Cr",
          },
          total_returns: {
            actual_value: "3173731.8400",
            value: "31.74",
            value_type: "lacs",
          },
          irr: "7.91",
          invested_value: {
            actual_value: "48340000.0000",
            value: "4.83",
            value_type: "Cr",
          },
          int_div: {
            amount: {
              actual_value: "0.0000",
              value: "0.00",
              value_type: "",
            },
            percentage: null,
          },
          unrealised_gain: {
            amount: {
              actual_value: "3173731.8400",
              value: "31.74",
              value_type: "lacs",
            },
            percentage: "6.57",
          },
          realised_gain: {
            amount: {
              actual_value: "0.0000",
              value: "0.00",
              value_type: "",
            },
            percentage: "",
          },
          measureinstrumentid: null,
          commitment_val: null,
          maturity_Date: null,
        },
      },
    ],
  },
  {
    clientcode: "1",
    id: 0,
    assetClass: {
      clientcode: "1",
      id: 0,
      name: "Cash",
      defaultIndex: {
        clientcode: null,
        id: 0,
        name: null,
      },
    },
    allocation_percentage: "",
    investmentreturn: {
      clientcode: "1",
      as_of_date: "2023-11-27",
      current_value: {
        actual_value: "33071.73",
        value: "33.07",
        value_type: "k",
      },
      total_returns: {
        actual_value: null,
        value: null,
        value_type: null,
      },
      irr: "0.00",
      invested_value: {
        actual_value: "33071.73",
        value: "33.07",
        value_type: "k",
      },
      int_div: {
        amount: {
          actual_value: "0.00000",
          value: "0.00",
          value_type: "",
        },
        percentage: null,
      },
      unrealised_gain: {
        amount: {
          actual_value: "0.00",
          value: "0.00",
          value_type: "",
        },
        percentage: "0.00",
      },
      realised_gain: {
        amount: {
          actual_value: "0",
          value: "0.00",
          value_type: "",
        },
        percentage: "",
      },
      measureinstrumentid: null,
      commitment_val: null,
      maturity_Date: null,
    },
    instrumentVehiclesList: [],
  },
];

export const filterKeyNameArray = [
  "instrument_name",
  "qty",
  "Avg_buy_price",
  "cmp",
  "irr",
];
export const filterKeyValue = {
  current_value: "data_Curr_Value",
  par_value: "data_Par_Value",
  principal_paid_amt: "data_Principle_Amt",
  inv_value: "data_Inv_Value",
  int_div_others: "data_Int_Div",
  realised_Gains: "data_Real_Gai",
  total_gains: "data_Total_Gai",
  unrealised_gain: "data_Unre_Gain",
};

export const defaultTransactionSortConfig = {
  clmName: "transaction_date",
  isAscending: false,
  type: "date",
  keyLevel: 1,
  keysObj: { key1: "transaction_date" },
  dateFormat: "ymd",
};

export const defaultTaxSortConfig = {
  clmName: "days_held",
  isAscending: false,
  type: "numbers",
  keyLevel: 1,
  keysObj: { key1: "days_held" },
};

export const overallCustomExcelClms = [
  {
    label: "Instrument Name",
    key: "excelAssetClass",
  },
  {
    label: "Asset Class",
    key: "assetClass",
  },
  {
    label: "Sub Asset Class",
    key: "subAssetClass",
  },
  {
    label: "Current Value (INR)",
    key: "excelCurrValue",
    //align: "right",
  },
  {
    label: "Absolute returns (in INR)",
    key: "excelAbsAmount",
  },
  {
    label: "Portfolio - IRR (in %)",
    key: "xirr",
    cellRendererPdf: (data, row, key) =>
      getPerfOverallExcelPercentage(data, row, key),
  },
  {
    label: "Benchmark - IRR (in %)",
    key: "excelBenchXirr",
    sortable: false,
    cellRendererPdf: (data, row, key) =>
      getPerfOverallExcelPercentage(data, row, key),
  },
];
export const taxReportTabs = [
  {
    label: "Asset Class",
    value: "Asset",
  },
  {
    label: "Int/Div/Others",
    value: "InterestDiv",
  },
];

export const taxReportBulletPoints = [
  "This Capital gains report does not include details on capital gains from PMS and AIF schemes if any. Kindly contact your Relationship Manager for the same.",
  "GF Price is Grandfathered Price",
  "Please consult your Relationship Manager for the Tax Deduction related queries on Capital Gain section.",
  " Arbitrage fund are taxed like equity funds. Hence you will need to ensure they are correctly mapped",
];

export const taxAccountDDPosition = {
  top: "56px",
  left: "0px",
  ZIndex: "20",
  padding: "3px",
  overflowY: "hidden",
  border: "1px solid #e3e3e3",
  maxWidth: "inherit",
};

export const unrealSubAssetDDPosition = {
  top: "56px",
  left: "0px",
  zIndex: "20",
  padding: "3px",
  overflowY: "hidden",
  border: "1px solid #e3e3e3",
};

export const goldenFill = {
  type: "pattern",
  pattern: "solid",
  fgColor: {
    argb: "FFCCA75E",
  },
};

export const headerFill = {
  type: "pattern",
  pattern: "solid",
  fgColor: {
    argb: "FF03002F",
  },
};
export const headerFont = {
  color: { argb: "FFFFFFFF" },
};

export const excelClmReference = [
  "Transaction Type",
  "Price",
  "Qty",
  "Amount",
  "Date",
  "Asset Class",
  "Sub Asset Class",
  "Expiry Date",
  "Current Value",
  "Absolute Return",
  "XIRR",
  "Client Name",
  "Account Name",
];

export const fileDownloadingMessage =
  "This usually takes 2 to 5 mins to download";

export const errorModalPadding = {
  padding: "25px 25px 33px",
};
export const somethingWrongErr =
  "Something went wrong, Please try again after sometime.";

export const allExcelClms = [
  {
    label: "Asset Class",
    key: "assetClass",
  },
  {
    label: "Sub Asset Class",
    key: "subAssetClass",
  },
];

export const somethingWrongErrAll =
  "Something went wrong, Please try again after sometime.";

export const noDataError =
  "No data available for the selected date range. Please try selecting a different period";

export const aquisitionValue = {
  0: "Transfer-In Date",
  1: "Inception Date",
};

export const uglAcquisitionError =
  "Failed to fetched the reports date type, Please try again after some time.";

export const buildDetails = `Build version : 16-10-2026 (Build 340)`;

export const UGLReportName = "Unrealised Gain Loss Report";

export const portfolioMenuDetails = [
  { heading: "Domestic Portfolio", key: "domestic", navigateTo: "/portfolio" },
  { heading: "Global Portfolio", key: "global", navigateTo: "/portfolio" },
];

export const financialSummary = "Financial Assets Summary";

export const offshoretitle = "Your Investments in";

export const allocSummary = "Allocation Summary";

export const offshoreAllocSummary = "Global Allocation Summary";

export const currencyMsg =
  "Toggle to view instruments by currency - no conversion is performed";

export const domestic = { name: "Domestic only", key: "domestic", apiValue: 0 };
export const global = { name: "Global only", key: "global", apiValue: 1 };
export const combined = {
  name: "Domestic & Global Combined",
  key: "combined",
  apiValue: 2,
};
export const noTransaction = {
  name: "No Transaction",
  key: "noTransaction",
  apiValue: 3,
};

export const offshoreValues = {
  o: "domestic",
  1: "global",
  2: "combined",
  3: "noTransaction",
};

export const FINANCIALTAB = "financial";
export const DOMESTIC = "domestic";
export const OFFSHORE = "global";
export const COMBINED = "combined";
export const NOTRANSACTION = "noTransaction";

export const portfolioReportType = [combined, domestic, global]; // According to order in which we display report type
export const portfolioReportValues = [
  domestic,
  global,
  combined,
  noTransaction,
]; // According to domestic/global values which we get from api

export const financialExcelClms = [
  { label: "Asset Class", key: "asset_class" }, // Top level data
  { label: "Allocation(%)", key: "allocation" },
  {
    label: "Current Value",
    key: "curr_value",
  },
  { label: "Inv value", key: "inv_value" }, // Top level data
  { label: "Int/Div", key: "int_div" },
  {
    label: "Unrealised Gain",
    key: "unrealised_gain",
  }, // Top level data
  {
    label: "Unrealised(%)",
    key: "unrealised_percentage",
  },
  { label: "Realised Gain", key: "realised_gain" },
  { label: "IRR(%)", key: "irr" },
];

export const liabilityAccordionRow = [
  { valueKey: "name", styleObj: { width: "70%" } },
  {
    valueKey: "sanctionedLimit_amount",
    styleObj: { width: "16%" },
    isNum: true,
  },
  { valueKey: "amount", styleObj: { width: "19%" }, isNum: true },
];

export const accordionTableHeaderData = [
  {
    title: "Asset Class",
    key: "name",
    sortable: true,
    width: "70%",
  },
  {
    title: "Sanctioned",
    key: "sanctionedLimit_amount",
    sortable: true,
    width: "16%",
  },
  {
    title: "Outstanding",
    key: "amount",
    sortable: true,
    width: "19%",
  },
  {
    title: "Action",
    sortable: false,
    width: "8%",
  },
];

export const deafaultOffshoreApiStatus = {
  getUsersCurrency: "pending",
  getUsersPortfolioReturn: "pending",
  // getUsersPortfolio: "pending",
  getUsersPortfolioAssetClasses: "pending",
  getUsersSubAssetClasses: "pending",
  getUsersReturnsLine: "pending",
  getFamilyView: "pending",

  getSettingsData: "pending",
  getLiasionData: "pending",
  getConnectData: "pending",
  getProfile: "pending",
  getFamilyData: "pending",
  getPortfolioReturnData: "pending",
  getPortfolioData: "pending",
};

export const deafaultOffshoreTabApiStatus = {
  getUsersPortfolioReturn: "pending",
  // getUsersPortfolio: "pending",
  getUsersPortfolioAssetClasses: "pending",
  getUsersSubAssetClasses: "pending",
  getUsersReturnsLine: "pending",
  getFamilyView: "pending",
  // getProfile: "pending",
  // getfamilyAccessOrLiasionData : "pending"
};

export const OffshoreApiStatusOnMemberChange = {
  getUsersCurrency: "pending",
  getUsersPortfolioReturn: "pending",
  //  getUsersPortfolio: "pending",
  getUsersPortfolioAssetClasses: "pending",
  getUsersSubAssetClasses: "pending",
  getUsersReturnsLine: "pending",
  getFamilyView: "pending",
  // getProfile: "pending",
  // getfamilyAccessOrLiasionData : "pending"
};

export const OFFSHORE_SUB_ASSET_PAGE = "global-sub-asset-class";
export const offshoreSummaryId = "globalSummaryId";

export const defaultOffshoreSubAssetApiStatus = {
  assetClass: "pending",
  currency: "pending",
  instruments: "pending",
};

export const pendingOffshoreSubAssetApiStatus = {
  assetClass: "pending",
  currency: "pending",
  instruments: "pending",
};

export const portFolioNoDataSubAssetClassMsg =
  "You do not have any Financial Assets with Nuvama to report";

export const offshoreNoDataSubAssetClassMsg =
  "You don't have any Global Investments held with Nuvama";

export const currencySymbols = {
  usd: "$",
  eur: "€",
  gbp: "£",
  jpy: "¥",
};

export const noDataFinancialAssets =
  "You do not have any Financial Assets with Nuvama to report";
export const noDataOffshore =
  "You dont have any Global Investments held with Nuvama";
export const errorText = "Oops, Something Went Wrong!";
export const OFFSHOREDATA = "globalData";

export const portfolioAssetClassesPdfTableColumns = [
  { label: "Asset Class", key: "asset_class" }, // Top level data
  { label: "Allocation(%)", key: "allocation" },
  {
    label: "Current Value",
    key: "curr_value",
  },
  { label: "Inv Value", key: "inv_value" }, // Top level data
  { label: "Int/Div", key: "int_div" },
  { label: "Unrealised Gain", key: "unrealised_gain" }, // Top level data
  { label: "Unrealised(%)", key: "unrealised_percentage" },
  { label: "Realised Gain", key: "realised_gain" },
  { label: "IRR(%)", key: "irr" },
];

export const offshoreAssetClassSheetName = "Asset Class Summary (Global)";
export const financialAssetClassSheetName = "Asset Class Summary";
export const infinityAssetClassSheetName = "Infinity - Asset Class Summary";
export const commonPageTitle = "Nuvama | Private Wealth Management";

export const logoAriaLabel =
  "Nuvama Private | Wealth Management Services | Financial Advisory Firm";

export const noSearchResult = "No results match your search";

export const dateErrorMessagetaxReport =
  "Date range cannot be more than 2 years";

export const monthMap = {
  January: "01",
  February: "02",
  March: "03",
  April: "04",
  May: "05",
  June: "06",
  July: "07",
  August: "08",
  September: "09",
  October: "10",
  November: "11",
  December: "12",
};

export const excelPdfDisclaimerLink = {
  text: "Master Disclaimer",
  link: "https://www.nuvamaprivate.com/disclaimer/",
};
export const homePageRoute = "homepage";

export const exportDataMenu = [
  { title: "Export to Excel", type: "excel", className: "listitem_icon excel" },
  { title: "Export to PDF", type: "pdf", className: "listitem_icon pdf" },
];

export const exportDataMenuTaxReport = [
  { title: "Export to Excel", type: "excel", className: "listitem_icon excel" },
  { title: "Export to PDF", type: "pdf", className: "listitem_icon new_pdf" },
  { title: "Email Report", type: "email", className: "listitem_icon pdf" },
];

export const exportDataMenuUGLReport = [
  {
    title: "Export All in Excel",
    type: "allExcel",
    className: "listitem_icon excel",
  },
  { title: "Export to Excel", type: "excel", className: "listitem_icon excel" },
  { title: "Export to PDF", type: "pdf", className: "listitem_icon pdf" },
];

export const stockHoldingExportMenu = [
  { type: "checkbox-selector", className: "" },
  { type: "download-button", className: "listitem_icon pdf" },
];

export const reportTypeValues = {
  "Transfer-In Date": "(Transfer In)",
  "Inception Date": "(Inception)",
};

export const connectoRoles = {
  RM: "Relationship Manager",
  CXO: "Customer Experience Officer",
  "Investment Advisor": "Investment Advisor",
};

export const defaultSecondaryRMData = {
  isLoading: true,
  error: "",
  data: null,
};
